module.exports = __webpack_public_path__ + "img/Flag_of_the_Comoros.4a55711b.svg";